import { memo } from 'react';
import { IconBolt } from '@optimizely/axiom-icons';
import { NodeProps } from '@xyflow/react';

import { NodeConnectionTypes, NodeTypeCategory } from '../../types/connections';
import { NODE_TYPE } from '../../types/node';
import { defineNode } from '../../utils/node-factory';
import { BaseNodeRenderer } from '../components/renderers/BaseNodeRenderer/BaseNodeRenderer';

/**
 * Configuration for the Conditional Step node type.
 * Routes workflow execution based on conditions evaluated by an agent.
 */
export const conditionalStepConfig = defineNode({
  description: {
    displayName: 'Conditional Step',
    name: NODE_TYPE.CONDITIONAL,
    description: 'Route workflow execution based on conditions evaluated by an agent',
    iconInfo: {
      icon: IconBolt,
      color: 'fg.avatar.purple',
    },
    category: NodeTypeCategory.LOGIC,
    input: {
      type: NodeConnectionTypes.Main,
      filter: {
        allowedNodeTypes: [
          { type: NODE_TYPE.SPECIALIZED, maxConnections: 10 },
          { type: NODE_TYPE.CONDITIONAL, maxConnections: 10 },
          { type: NODE_TYPE.FOR_LOOP, maxConnections: 10 },
          { type: NODE_TYPE.CONDITION, maxConnections: 10 },
          { type: NODE_TYPE.NESTED_WORKFLOW, maxConnections: 10 },
        ],
      },
    },
    output: {
      type: NodeConnectionTypes.Main,
      displayName: 'Default',
      category: 'condition',
      maxConnections: 10,
      minConnections: 1,
      filter: {
        allowedNodeTypes: [{ type: NODE_TYPE.CONDITION, maxConnections: 10 }],
      },
    },
    properties: [
      {
        displayName: 'Name',
        name: 'name',
        type: 'string',
        required: true,
        default: '',
        description: 'A descriptive name for this conditional step',
      },
      {
        displayName: 'Description',
        name: 'description',
        type: 'string',
        required: false,
        default: '',
        description: 'Optional description of what this step evaluates',
      },
    ],
    defaults: {
      name: 'Conditional Step',
      parameters: {
        name: '',
        description: '',
      },
    },
  },

  render: memo(function ConditionalStepRenderer(props: NodeProps) {
    return <BaseNodeRenderer {...props} />;
  }),
});
